import React from "react";
import { Grid, Link, Text } from "~/components-shared";
import fallbackImage from "~/assets/i/image-fallback.jpg";
import Markdown from "~/components/Markdown";
import styled from "styled-components";
import { resolveSlackChannelName } from "~/lib/helpers";
import Collapsable from "~/components/Collapsable";
import FootprintActions from "~/components/FootprintActions";
import SlackFootprintBotTemplates from "~/components/SlackFootprintBotTemplates";
const StyledMarkdown = styled(Markdown)`
  & > span {
    display: inline-block;
  }
`;
const StyledLink = styled(Link)`
  border-radius: ${_ref => {
  let {
    theme
  } = _ref;
  return theme.shape.borderRadius.primary;
}};
  padding: ${_ref2 => {
  let {
    theme
  } = _ref2;
  return theme.typography.fontStep * 2;
}}rem;
  background-color: ${_ref3 => {
  let {
    theme
  } = _ref3;
  return theme.colors.background.secondary;
}};
`;
const FileImg = styled.img`
  width: auto;
  height: auto;
  overflow: hidden;
  border-radius: ${_ref4 => {
  let {
    theme
  } = _ref4;
  return theme.shape.borderRadius.primary;
}};
  margin-bottom: ${_ref5 => {
  let {
    theme
  } = _ref5;
  return theme.typography.fontStep;
}}rem;
`;
const TopicFootprintContentSlack = _ref6 => {
  let {
    footprint,
    hideDetails = false,
    hideMessage = false
  } = _ref6;
  const {
    actions,
    isHidden,
    isPrivate,
    data: {
      channelName,
      channelUrl,
      url,
      files,
      threadId,
      isBot
    }
  } = footprint;
  const typeLink = url ? `a Slack [message](${url})` : `a Slack message`;
  const threadLink = threadId ? "thread" : "";
  const channel = isHidden ? "🔒 private" : resolveSlackChannelName(channelName, channelUrl, isPrivate);
  return /*#__PURE__*/React.createElement(React.Fragment, null, !hideDetails && /*#__PURE__*/React.createElement(Text, {
    display: "block",
    color: "textSecondary",
    weight: "semiBold"
  }, /*#__PURE__*/React.createElement(FootprintActions, {
    actions: actions
  }), " ", /*#__PURE__*/React.createElement(StyledMarkdown, {
    s: {
      mb: 1
    },
    text: `${typeLink} in ${channel} channel ${threadLink}`
  })), !hideMessage && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Collapsable, null, /*#__PURE__*/React.createElement(Markdown, {
    text: footprint.data.text,
    fontSize: 4,
    lineHeight: 6,
    display: "block"
  }), !!files && /*#__PURE__*/React.createElement(Grid, {
    cols: 2,
    gap: 3,
    template: "minmax(100px, 300px) minmax(100px, 300px) minmax(100px, 300px)",
    s: {
      mt: 2
    }
  }, files.map(file => /*#__PURE__*/React.createElement(StyledLink, {
    key: file.id,
    href: file.permalink
  }, file.image && /*#__PURE__*/React.createElement(FileImg, {
    src: file.image,
    width: "100%",
    height: "100%",
    onError: event => {
      event.currentTarget.src = fallbackImage;
    },
    alt: file.title
  }), /*#__PURE__*/React.createElement(Text, {
    weight: "semiBold",
    display: "block",
    color: "textSecondary",
    fontSize: 2.5
  }, file.prettyType), /*#__PURE__*/React.createElement(Text, {
    weight: "semiBold",
    display: "block",
    fontSize: 3
  }, file.title))))), isBot && /*#__PURE__*/React.createElement(SlackFootprintBotTemplates, {
    footprint: footprint
  })));
};
export default TopicFootprintContentSlack;